/**
 * @file: TaskAssignedBody.tsx
 *
 * `OrgTaskAssigned` — a task was assigned to a technician. Two
 * phrasings based on the actor:
 *
 *   - assigner == technician (self-claim): `{name} 认领了「T」任务`
 *   - assigner != technician (assigned to someone else):
 *     `{assignerName} 将「T」任务派给了 {technicianName}`
 *
 * The duplicate avatar+name row that used to sit under the title is
 * gone — the timeline's footer author chip already shows the actor,
 * so repeating the technician inline was just visual noise.
 */

import { FeedInboxItem, OrgTaskAssignedFeedPayload } from '@euler/model/feed';
import { idEquals } from '@euler/utils';
import { FC } from 'react';
import { View } from 'react-native';
import { BodyText, TitleText } from './common/primitives';

export const TaskAssignedBody: FC<{
  p: OrgTaskAssignedFeedPayload;
  author?: FeedInboxItem['author'];
}> = ({ p, author }) => {
  const isSelfClaim = author?.id != null && idEquals(author.id, p.technicianId);
  const taskClause = p.taskName ? `「${p.taskName}」任务` : '任务';
  const title = isSelfClaim
    ? `${p.technicianName} 认领了${taskClause}`
    : `${author?.name ?? '同事'} 将${taskClause}派给了 ${p.technicianName}`;
  return (
    <View>
      <TitleText>{title}</TitleText>
      {p.serviceSubjects ? (
        <BodyText mt={6} color="#6b7280">
          {p.serviceSubjects}
        </BodyText>
      ) : null}
    </View>
  );
};
